// @flow

import { observable } from 'mobx';
import Labor from './Labor'
import LaborUebermittlung from './LaborUebermittlung'
import LaborAbteilung from './LaborAbteilung'

export default class AnalyseLabor {
  @observable abteilung: LaborAbteilung = new LaborAbteilung();
  @observable labor: Labor = new Labor();

  constructor(json?: any) {
    if(json) {
      this.abteilung = new LaborAbteilung(json.abteilung);
      this.labor = new Labor(json.labor);
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/Model/AnalyseLabor.js